"use client";

import { cn } from "@/utils";
import { useTocActive } from "./TocActiveProvider";

type TocAnchorProps = {
  anchorId: string;
  text: string;
};

const TocAnchor = ({ anchorId, text }: TocAnchorProps) => {
  const { activeId, setActiveId } = useTocActive();

  return (
    <a
      href={`#${anchorId}`}
      aria-current={activeId === anchorId ? "true" : undefined}
      className={cn(
        "jlt-block jlt-rounded-[11px] jlt-px-3 jlt-py-[7px] jlt-text-[13.5px] jlt-transition-colors jlt-duration-150",
        activeId === anchorId
          ? "jlt-bg-pl-blue-soft jlt-text-pl-blue"
          : "jlt-text-pl-ink2 hover:jlt-bg-pl-blue-soft hover:jlt-text-pl-blue",
      )}
      onClick={(e) => {
        const element = document.getElementById(anchorId);
        if (!element) return;

        e.preventDefault();
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        // Highlight straight away; the scroll listener takes over once the
        // smooth scroll settles.
        setActiveId(anchorId);
      }}
    >
      {text}
    </a>
  );
};

export default TocAnchor;
